import React from "react";
import { Box, Typography } from "@mui/material";
import SubtitleBox from "../SubtitleBox";

const AIAvatar = ({
  aiProfile,
  userTranscript,
  processingStatusText,
  showInitialFeedback,
  hasShownIntroCC,
  showCC,
  t,
  isMobile,
  recordingNearLimit,
  avatarStatus,
}) => {
  const getStatusColor = (status) => {
    switch (status) {
      case "processing-warm":
        return "#ff9800";
      case "processing-thinking":
        return "#ffeb3b";
      case "processing-ready":
        return "#2196f3";
      case "thinking":
      case "speaking":
        return "#2196f3";
      default:
        return "#4caf50";
    }
  };

  const statusColor = getStatusColor(avatarStatus);

  const pulseKeyframes = `
    @keyframes dynamicPulse {
      0%   { box-shadow: 0 0 12px ${statusColor}80; }
      50%  { box-shadow: 0 0 30px ${statusColor}; }
      100% { box-shadow: 0 0 12px ${statusColor}80; }
    }
  `;

  const subtitleText = userTranscript
    ? userTranscript
    : !hasShownIntroCC && showInitialFeedback
    ? t("ai_feedback")
    : "";

  return (
    <Box textAlign="center" sx={{ position: "relative", mt: { xs: 1, sm: 0 } }}>
      <Box
        sx={{
          width: { xs: 230, sm: 360 },
          height: { xs: 230, sm: 360 },
          borderRadius: "50%",
          mx: "auto",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "rgba(255,255,255,0.2)",
          border: `4px solid ${statusColor}`,
          animation: "dynamicPulse 1.5s ease-in-out infinite",
          transition: "all 0.3s ease",
          overflow: "hidden",
          mt: { xs: 5, sm: 4 },
        }}
      >
        {aiProfile?.avatar_url ? (
          <img
            src={aiProfile.avatar_url.startsWith("/images")
              ? aiProfile.avatar_url
              : `/images/ai_profiles/${aiProfile.avatar_url}`}
            alt={aiProfile.name}
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
        ) : (
          <Box
            sx={{
              px: 2,
              py: 1,
              bgcolor: "rgba(0,0,0,0.5)",
              borderRadius: "999px",
              border: "2px solid #fff",
            }}
          >
            <Typography sx={{ color: "#fff", textAlign: "center" }}>
              {aiProfile?.name || "Avatar AI"}
            </Typography>
          </Box>
        )}
      </Box>

      {showCC && (
        <SubtitleBox
          show={showCC}
          text={subtitleText}
          secondaryText={userTranscript ? processingStatusText : ""}
          width={isMobile ? 350 : 650}
          maxRows={isMobile ? 10 : 5}
        />
      )}

      <style>{pulseKeyframes}</style>
    </Box>
  );
};

export default AIAvatar;
